import React from "react";

interface IconProps {
  className?: string;
  size?: number;
}

export const GitHubIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
  </svg>
);

export const LinkedInIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

export const EmailIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M24 5.457v13.909c0 .904-.732 1.636-1.636 1.636h-3.819V11.73L12 16.64l-6.545-4.91v9.273H1.636A1.636 1.636 0 0 1 0 19.366V5.457c0-.9.732-1.636 1.636-1.636h.98l9.382 7.05 9.382-7.05h.98c.904 0 1.636.732 1.636 1.636z" />
  </svg>
);

export const LocationIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
  </svg>
);

export const CloseIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
  </svg>
);

export const ExternalLinkIcon: React.FC<IconProps> = ({
  className = "",
  size = 20,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z" />
  </svg>
);

// New icons for Skills component
export const CodeIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0L19.2 12l-4.6-4.6L16 6l6 6-6 6-1.4-1.4z" />
  </svg>
);

export const GlobeIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
  </svg>
);

export const DatabaseIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 3C7.58 3 4 4.79 4 7s3.58 4 8 4 8-1.79 8-4-3.58-4-8-4zM4 9v3c0 2.21 3.58 4 8 4s8-1.79 8-4V9c0 2.21-3.58 4-8 4s-8-1.79-8-4zm0 5v3c0 2.21 3.58 4 8 4s8-1.79 8-4v-3c0 2.21-3.58 4-8 4s-8-1.79-8-4z" />
  </svg>
);

export const BriefcaseIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M10 16V15H14V16C14 16.55 13.55 17 13 17H11C10.45 17 10 16.55 10 16ZM20 7H16V5L14 3H10L8 5V7H4C2.9 7 2 7.9 2 9V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V9C22 7.9 21.1 7 20 7ZM10 5H14V7H10V5Z" />
  </svg>
);

export const AwardIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 7C12.55 7 13 6.55 13 6S12.55 5 12 5 11 5.45 11 6 11.45 7 12 7ZM14 9H10V11H14V9ZM12 1L9 4H15L12 1ZM18.5 3.5L17 5L19 7L20.5 5.5L18.5 3.5ZM5.5 3.5L3.5 5.5L5 7L7 5L5.5 3.5ZM12 15C10.34 15 9 13.66 9 12S10.34 9 12 9 15 10.34 15 12 13.66 15 12 15ZM12 17C14.76 17 17 14.76 17 12S14.76 7 12 7 7 9.24 7 12 9.24 17 12 17ZM12 19C8.69 19 6 16.31 6 13H4C4 17.42 7.58 21 12 21S20 17.42 20 13H18C18 16.31 15.31 19 12 19Z" />
  </svg>
);

export const UserIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
  </svg>
);

// Programming Language Icons
export const JavaIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M8.851 18.56s-.917.534.653.714c1.902.218 2.874.187 4.969-.211 0 0 .552.346 1.321.646-4.699 2.013-10.633-.118-6.943-1.149M8.276 15.933s-1.028.761.542.924c2.032.209 3.636.227 6.413-.308 0 0 .384.389.987.602-5.679 1.661-12.007.13-7.942-1.218M13.116 11.475c1.158 1.333-.304 2.533-.304 2.533s2.939-1.518 1.589-3.418c-1.261-1.772-2.228-2.652 3.007-5.688 0-.001-8.216 2.051-4.292 6.573M19.33 20.504s.679.559-.747.991c-2.712.822-11.288 1.069-13.669.033-.856-.373.75-.89 1.254-.998.527-.114.828-.93.828-.93-.953.671-6.156 1.317-2.643 1.887 9.58 1.553 17.462-.7 14.977-1.549M9.292 13.21s-4.362 1.036-1.544 1.412c1.189.159 3.561.123 5.77-.062 1.806-.152 3.618-.477 3.618-.477s-.637.272-1.098.587c-4.429 1.165-12.986.623-10.522-.568 2.082-1.006 3.776-.892 3.776-.892M17.116 17.584c4.503-2.34 2.421-4.589.968-4.285-.355.074-.515.138-.515.138s.132-.207.385-.297c2.875-1.011 5.086 2.981-.928 4.562 0-.001.070-.062.09-.118M14.401 0s2.494 2.494-2.365 6.33c-3.896 3.077-.888 4.832-.001 6.836-2.274-2.053-3.943-3.858-2.824-5.539 1.644-2.469 6.197-3.665 5.19-7.627M9.734 23.924c4.322.277 10.959-.153 11.116-2.198 0 0-.302.775-3.572 1.391-3.688.694-8.239.613-10.937.168 0-.001.553.457 3.393.639" />
  </svg>
);

export const PythonIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M14.25.18l.9.2.73.26.59.3.45.32.34.34.25.34.16.33.1.3.04.26.02.2-.01.13V8.5l-.05.63-.13.55-.21.46-.26.38-.3.31-.33.25-.35.19-.35.14-.33.1-.3.07-.26.04-.21.02H8.77l-.69.05-.59.14-.5.22-.41.27-.33.32-.27.35-.2.36-.15.37-.1.35-.07.32-.04.27-.02.21v3.06H3.17l-.21-.03-.28-.07-.32-.12-.35-.18-.36-.26-.36-.36-.35-.46-.32-.59-.28-.73-.21-.88-.14-1.05-.05-1.23.06-1.22.16-1.04.24-.87.32-.71.36-.57.4-.44.42-.33.42-.24.4-.16.36-.1.32-.05.26-.02.21-.01h5.84l.69-.05.59-.14.5-.21.41-.28.33-.32.27-.35.2-.36.15-.36.1-.35.07-.32.04-.28.02-.21V6.07h2.09l.14.01zm-6.47 14.25c-.2 0-.38.09-.5.25-.12.16-.18.38-.18.61 0 .22.06.44.18.61.12.16.3.25.5.25.18 0 .35-.09.46-.25.12-.17.19-.39.19-.61 0-.23-.07-.45-.19-.61-.11-.16-.28-.25-.46-.25z" />
  </svg>
);

export const Html5Icon: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M1.5 0h21l-1.91 21.563L11.977 24l-8.564-2.438L1.5 0zm7.031 9.75l-.232-2.718 10.059.003.23-2.622L5.412 4.41l.698 8.01h9.126l-.326 3.426-2.91.804-2.955-.81-.188-2.11H6.248l.33 4.171L12 19.351l5.379-1.443.744-8.157H8.531z" />
  </svg>
);

export const Css3Icon: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M1.5 0h21l-1.91 21.563L11.977 24l-8.565-2.438L1.5 0zm17.09 4.413L5.41 4.41l.213 2.622 10.125.002-.255 2.716h-6.64l.24 2.573h6.182l-.366 3.523-2.91.804-2.956-.81-.188-2.11h-2.61l.29 3.855L12 19.288l5.373-1.53L18.59 4.414z" />
  </svg>
);

export const ReactIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M14.23 12.004a2.236 2.236 0 0 1-2.235 2.236 2.236 2.236 0 0 1-2.236-2.236 2.236 2.236 0 0 1 2.235-2.236 2.236 2.236 0 0 1 2.236 2.236zm2.648-10.69c-1.346 0-3.107.96-4.888 2.622-1.78-1.653-3.542-2.602-4.887-2.602-.41 0-.783.093-1.106.278-1.375.793-1.683 3.264-.973 6.365C1.98 8.917 0 10.42 0 12.004c0 1.59 1.99 3.097 5.043 4.03-.704 3.113-.39 5.588.988 6.38.32.187.69.275 1.102.275 1.345 0 3.107-.96 4.888-2.624 1.78 1.654 3.542 2.603 4.887 2.603.41 0 .783-.09 1.106-.275 1.374-.792 1.683-3.263.973-6.365C22.02 15.096 24 13.59 24 12.004c0-1.59-1.99-3.097-5.043-4.032.704-3.11.39-5.587-.988-6.38-.318-.184-.688-.277-1.092-.278zm-.005 1.09v.006c.225 0 .406.044.558.127.666.382.955 1.835.73 3.704-.054.46-.142.945-.25 1.44-.96-.236-2.006-.417-3.107-.534-.66-.905-1.345-1.727-2.035-2.447 1.592-1.48 3.087-2.292 4.105-2.295zm-9.77.02c1.012 0 2.514.808 4.11 2.28-.686.72-1.37 1.537-2.02 2.442-1.107.117-2.154.298-3.113.538-.112-.49-.195-.964-.254-1.42-.23-1.868.054-3.32.714-3.707.19-.09.4-.127.563-.132zm4.882 3.05c.455.468.91.992 1.36 1.564-.44-.02-.89-.034-1.36-.034-.47 0-.92.014-1.36.034.44-.572.895-1.096 1.36-1.564zM12 8.1c.74 0 1.477.034 2.202.093.406.582.802 1.203 1.183 1.86.372.64.71 1.29 1.018 1.946-.308.655-.646 1.31-1.013 1.95-.38.66-.773 1.288-1.18 1.87-.728.063-1.466.098-2.21.098-.74 0-1.477-.035-2.202-.093-.406-.582-.802-1.204-1.183-1.86-.372-.64-.71-1.29-1.018-1.946.303-.657.646-1.313 1.013-1.954.38-.66.773-1.286 1.18-1.868.728-.064 1.466-.098 2.21-.098zm-3.635.254c-.24.377-.48.763-.704 1.16-.225.39-.435.782-.635 1.174-.265-.656-.49-1.31-.676-1.947.64-.15 1.315-.283 2.015-.386zm7.26 0c.695.103 1.365.23 2.006.387-.18.632-.405 1.282-.66 1.933-.2-.39-.41-.783-.64-1.174-.225-.392-.465-.774-.705-1.146zm3.063.675c.484.15.944.317 1.375.498 1.732.74 2.852 1.708 2.852 2.476-.005.768-1.125 1.74-2.857 2.475-.42.18-.88.342-1.355.493-.28-.958-.646-1.956-1.1-2.98.45-1.017.81-2.01 1.085-2.964zm-13.395.004c.278.96.645 1.957 1.1 2.98-.45 1.017-.812 2.01-1.086 2.964-.484-.15-.944-.318-1.37-.5-1.732-.737-2.852-1.706-2.852-2.474 0-.768 1.12-1.742 2.852-2.476.42-.18.88-.342 1.356-.494zm11.678 4.28c.265.657.49 1.312.676 1.948-.64.157-1.316.29-2.016.39.24-.375.48-.762.705-1.158.225-.39.435-.788.636-1.18zm-9.945.02c.2.392.41.783.64 1.175.23.39.465.772.705 1.143-.695-.102-1.365-.23-2.006-.386.18-.63.406-1.282.66-1.933zM17.92 16.32c.112.493.2.968.254 1.423.23 1.868-.054 3.32-.714 3.708-.147.09-.338.128-.563.128-1.012 0-2.514-.807-4.11-2.28.686-.72 1.37-1.536 2.02-2.44 1.107-.118 2.154-.3 3.113-.54zm-11.83.01c.96.234 2.006.415 3.107.532.66.905 1.345 1.727 2.035 2.446-1.595 1.483-3.092 2.295-4.11 2.295-.22-.005-.406-.05-.553-.132-.666-.38-.955-1.834-.73-3.703.054-.46.142-.944.25-1.438zm4.56.64c.44.02.89.034 1.36.034.47 0 .92-.014 1.36-.034-.44.572-.895 1.095-1.36 1.56-.455-.467-.91-.991-1.36-1.56z" />
  </svg>
);

export const NodeJsIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M11.998,24c-0.321,0-0.641-0.084-0.922-0.247l-2.936-1.737c-0.438-0.245-0.224-0.332-0.08-0.383 c0.585-0.203,0.703-0.25,1.328-0.604c0.065-0.037,0.151-0.023,0.218,0.017l2.256,1.339c0.082,0.045,0.197,0.045,0.272,0l8.795-5.076 c0.082-0.047,0.134-0.141,0.134-0.238V6.921c0-0.099-0.053-0.192-0.137-0.242l-8.791-5.072c-0.081-0.047-0.189-0.047-0.271,0 L2.46,6.68C2.376,6.729,2.322,6.825,2.322,6.921v10.15c0,0.097,0.054,0.189,0.137,0.235l2.409,1.392 c1.307,0.654,2.108-0.116,2.108-0.89V7.787c0-0.142,0.114-0.253,0.256-0.253h1.115c0.139,0,0.255,0.112,0.255,0.253v10.021 c0,1.745-0.95,2.745-2.604,2.745c-0.508,0-0.909,0-2.026-0.551L2.28,18.675c-0.57-0.329-0.922-0.945-0.922-1.604V6.921 c0-0.659,0.353-1.275,0.922-1.603l8.795-5.082c0.557-0.315,1.296-0.315,1.848,0l8.794,5.082c0.570,0.329,0.924,0.944,0.924,1.603 v10.15c0,0.659-0.354,1.273-0.924,1.604l-8.794,5.078C12.643,23.916,12.324,24,11.998,24z M19.099,13.993 c0-1.9-1.284-2.406-3.987-2.763c-2.731-0.361-3.009-0.548-3.009-1.187c0-0.528,0.235-1.233,2.258-1.233 c1.807,0,2.473,0.389,2.747,1.607c0.024,0.115,0.129,0.199,0.247,0.199h1.141c0.071,0,0.138-0.031,0.186-0.081 c0.048-0.054,0.074-0.123,0.067-0.196c-0.177-2.098-1.571-3.076-4.388-3.076c-2.508,0-4.004,1.058-4.004,2.833 c0,1.925,1.488,2.457,3.895,2.695c2.88,0.282,3.103,0.703,3.103,1.269c0,0.983-0.789,1.402-2.642,1.402 c-2.327,0-2.839-0.584-3.011-1.742c-0.02-0.124-0.126-0.215-0.253-0.215h-1.137c-0.141,0-0.254,0.112-0.254,0.253 c0,1.482,0.806,3.248,4.655,3.248C17.501,17.007,19.099,15.91,19.099,13.993z" />
  </svg>
);

export const GitIcon: React.FC<IconProps> = ({ className = "", size = 24 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M23.546 10.93L13.067.452c-.604-.603-1.582-.603-2.188 0L8.708 2.627l2.76 2.76c.645-.215 1.379-.07 1.889.441.516.515.658 1.258.438 1.9l2.658 2.66c.645-.223 1.387-.078 1.9.435.721.72.721 1.884 0 2.604-.719.719-1.881.719-2.6 0-.539-.541-.674-1.337-.404-1.996L12.86 8.955v6.525c.176.086.342.203.488.348.713.721.713 1.883 0 2.6-.719.721-1.889.721-2.609 0-.719-.719-.719-1.879 0-2.598.182-.18.387-.316.605-.406V8.835c-.217-.091-.422-.227-.604-.406-.545-.545-.676-1.342-.396-2.009L7.636 3.7.45 10.881c-.6.605-.6 1.584 0 2.189l10.481 10.477c.604.604 1.582.604 2.186 0l10.43-10.43c.605-.603.605-1.582 0-2.187" />
  </svg>
);

export const JavaScriptIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M0 0h24v24H0V0zm22.034 18.276c-.175-1.095-.888-2.015-3.003-2.873-.736-.345-1.554-.585-1.797-1.14-.091-.33-.105-.51-.046-.705.15-.646.915-.84 1.515-.66.39.12.75.42.976.9 1.034-.676 1.034-.676 1.755-1.125-.27-.42-.404-.601-.586-.78-.63-.705-1.469-1.065-2.834-1.034l-.705.089c-.676.165-1.32.525-1.71 1.005-1.14 1.291-.811 3.541.569 4.471 1.365 1.02 3.361 1.244 3.616 2.205.24 1.17-.87 1.545-1.966 1.41-.811-.18-1.26-.586-1.755-1.336l-1.83 1.051c.21.48.45.689.81 1.109 1.74 1.756 6.09 1.666 6.871-1.004.029-.09.24-.705.074-1.65l.046.067zm-8.983-7.245h-2.248c0 1.938-.009 3.864-.009 5.805 0 1.232.063 2.363-.138 2.711-.33.689-1.18.601-1.566.48-.396-.196-.597-.466-.83-.855-.063-.105-.11-.196-.127-.196l-1.825 1.125c.305.63.75 1.172 1.324 1.517.855.51 2.004.675 3.207.405.783-.226 1.458-.691 1.811-1.411.51-.93.402-2.07.397-3.346.012-2.054 0-4.109 0-6.179l.004-.056z" />
  </svg>
);

export const TailwindIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12.001,4.8c-3.2,0-5.2,1.6-6,4.8c1.2-1.6,2.6-2.2,4.2-1.8c0.913,0.228,1.565,0.89,2.288,1.624 C13.666,10.618,15.027,12,18.001,12c3.2,0,5.2-1.6,6-4.8c-1.2,1.6-2.6,2.2-4.2,1.8c-0.913-0.228-1.565-0.89-2.288-1.624 C16.337,6.182,14.976,4.8,12.001,4.8z M6.001,12c-3.2,0-5.2,1.6-6,4.8c1.2-1.6,2.6-2.2,4.2-1.8c0.913,0.228,1.565,0.89,2.288,1.624 c1.177,1.194,2.538,2.576,5.512,2.576c3.2,0,5.2-1.6,6-4.8c-1.2,1.6-2.6,2.2-4.2,1.8c-0.913-0.228-1.565-0.89-2.288-1.624 C10.337,13.382,8.976,12,6.001,12z" />
  </svg>
);

export const MySqlIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M16.405 5.501c-.115 0-.193.014-.274.033v.013h.014c.054.104.146.18.214.274.054.107.1.214.154.32l.014-.015c.094-.066.14-.172.14-.333-.04-.047-.046-.094-.08-.14-.04-.067-.126-.1-.18-.153zM5.77 18.695h-.927a50.854 50.854 0 00-.27-4.41h-.008l-1.41 4.41H2.45l-1.4-4.41h-.01a72.892 72.892 0 00-.195 4.41H.085c.055-1.966.192-3.81.41-5.53h1.15l1.335 4.064h.008l1.347-4.064h1.095c.242 1.72.38 3.564.438 5.53zM9.362 18.695h-.927a50.854 50.854 0 00-.27-4.41h-.008l-1.41 4.41H5.04l-1.4-4.41h-.01a72.892 72.892 0 00-.195 4.41h-.756c.055-1.966.192-3.81.41-5.53h1.15l1.335 4.064h.008l1.347-4.064h1.095c.242 1.72.38 3.564.438 5.53zm7.591-.99c-.648.007-1.133-.039-1.504-.125-.372-.086-.669-.23-.892-.427-.223-.196-.371-.454-.446-.767-.074-.313-.099-.67-.072-1.067.027-.397.111-.794.252-1.192.142-.398.34-.776.595-1.135.255-.359.577-.678.966-.957.389-.279.851-.497 1.388-.653.537-.156 1.145-.235 1.824-.235.678 0 1.293.079 1.843.235.55.156 1.015.374 1.396.653.381.279.684.598.909.957.225.359.386.737.483 1.135.097.398.134.795.109 1.192-.025.397-.147.671-.367.823-.22.152-.556.228-1.009.228-.453 0-.827-.076-1.121-.228-.294-.152-.486-.426-.578-.823-.092-.397-.139-.844-.139-1.342 0-.498.047-.945.139-1.342.092-.397.284-.671.578-.823.294-.152.668-.228 1.121-.228.453 0 .789.076 1.009.228.22.152.342.426.367.823.025.397-.012.794-.109 1.192-.097.398-.258.776-.483 1.135-.225.359-.528.678-.909.957-.381.279-.846.497-1.396.653-.55.156-1.165.235-1.843.235-.679 0-1.287-.079-1.824-.235-.537-.156-.999-.374-1.388-.653-.389-.279-.711-.598-.966-.957-.255-.359-.453-.737-.595-1.135-.142-.398-.225-.795-.252-1.192-.027-.397-.002-.754.072-1.067.074-.313.223-.571.446-.767.223-.196.52-.341.892-.427.372-.086.856-.132 1.504-.125.648.007 1.306.086 1.973.235.668.149 1.344.361 2.028.637.684.275 1.377.616 2.078 1.022.701.406 1.41.876 2.127 1.409v-1.728c-.717-.481-1.462-.907-2.236-1.277-.774-.37-1.568-.676-2.382-.918-.814-.242-1.648-.417-2.501-.526-.853-.109-1.726-.163-2.619-.163-1.187 0-2.237.152-3.15.457-.913.305-1.688.727-2.325 1.266-.637.539-1.136 1.182-1.497 1.928-.361.746-.542 1.564-.542 2.454 0 .89.181 1.708.542 2.454.361.746.86 1.389 1.497 1.928.637.539 1.412.961 2.325 1.266.913.305 1.963.457 3.15.457.893 0 1.766-.054 2.619-.163.853-.109 1.687-.284 2.501-.526.814-.242 1.608-.548 2.382-.918.774-.37 1.519-.796 2.236-1.277v-1.728c-.717.533-1.426 1.003-2.127 1.409-.701.406-1.394.747-2.078 1.022-.684.275-1.36.488-2.028.637-.667.149-1.325.228-1.973.235zm2.64-2.897c-.028-.054-.053-.106-.081-.16-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.239-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.054-.08-.081-.12-.054-.08-.108-.16-.162-.238-.027-.04-.054-.08-.081-.12-.108-.16-.216-.32-.324-.479-.027-.04-.074-.076-.115-.114-.054-.04-.114-.066-.194-.1z" />
  </svg>
);

export const CSharpIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 0A12 12 0 000 12a12 12 0 0012 12 12 12 0 0012-12A12 12 0 0012 0zM9.426 7.12a5.55 5.55 0 011.985.38v1.181a4.5 4.5 0 00-2.025-.566 2.9 2.9 0 00-2.104.807 2.7 2.7 0 00-.807 2.104c0 .807.27 1.47.807 2.104a2.9 2.9 0 002.104.807 4.5 4.5 0 002.025-.566v1.181a5.55 5.55 0 01-1.985.38 4.16 4.16 0 01-2.986-1.181A3.9 3.9 0 015.22 12a3.9 3.9 0 011.181-2.986A4.16 4.16 0 019.387 7.833zM16.12 7.833c-.807 0-1.47.27-1.985.807a2.7 2.7 0 00-.807 2.104c0 .807.27 1.47.807 2.104a2.9 2.9 0 001.985.807c.807 0 1.47-.27 1.985-.807a2.7 2.7 0 00.807-2.104c0-.807-.27-1.47-.807-2.104a2.9 2.9 0 00-1.985-.807zm0 1.181c.526 0 .967.18 1.322.539.356.36.534.807.534 1.34 0 .534-.178.98-.534 1.34-.355.36-.796.539-1.322.539-.526 0-.967-.18-1.322-.539-.356-.36-.534-.807-.534-1.34 0-.534.178-.98.534-1.34.355-.36.796-.539 1.322-.539z" />
  </svg>
);

export const ExpressIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M24 18.588a1.529 1.529 0 01-1.895-.72l-3.45-4.771-.5-.667-4.003 5.444a1.466 1.466 0 01-1.802.708l5.158-6.92-4.798-6.251a1.595 1.595 0 011.9.666l3.576 4.83 3.596-4.81a1.435 1.435 0 011.788-.668L21.708 7.9l-2.522 3.283a.666.666 0 000 .994l4.804 6.412zM.002 11.576l.42-2.075c1.154-4.103 5.858-5.81 9.094-3.27 1.895 1.489 2.368 3.597 2.275 5.973H1.116C.943 16.447 4.005 19.009 7.92 17.7a4.078 4.078 0 002.582-2.876c.207-.666.548-.78 1.174-.588a5.417 5.417 0 01-2.589 3.957c-2.864 1.607-6.509.018-7.778-2.726a6.048 6.048 0 01-.307-3.89zm1.093-.576h10.05c.262-2.053-.814-4.051-2.794-4.792-2.049-.766-4.373.78-4.865 2.952a.59.59 0 01-.391.84z" />
  </svg>
);
export const LeftArrowIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
  </svg>
);

export const RightArrowIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z" />
  </svg>
);
